import React, { Component, Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, HashRouter, Route, Routes, useLocation } from 'react-router-dom'
import AxiosInterceptor from './app/helpers/AxiosInterceptor'
import ExpireStorage from './app/helpers/ExpireStorage'
import { Helpers } from './app/helpers/Helpers'
import { startListTableHeightWatcher } from './app/helpers/listTableHeight'
import Layout from './app/layouts/Layout'
import { GetCompanyListResponse } from './app/models/response/company/GetCompanyListResponse'
import { LoginResponse } from './app/models/response/user/LoginResponse'
import { storeCompanyList, storeCurrencyConversionList, storeSelectedCompany, storeUser } from './app/redux/reducers/authSlice'
import { RootState } from './app/redux/store'
import LoadingScreen from './app/screens/LoadingScreen/LoadingScreen'
import LoginScreen from './app/screens/LoginScreen/LoginScreen'
import toast from "react-hot-toast";
import { CompanyService } from './app/services/CompanyService'
import './AppJS.js'
import { GetActiveCurrencyConversions } from './app/models/response/currencyConversion/GetActiveCurrencyConversions'
import { CurrencyConversionService } from './app/services/CurrencyConversionService'

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

const App = () => {
    const dispatch = useDispatch()
    const auth = useSelector((state: RootState) => state.auth)

    // Liste tablolarının çerçevesi ölçülerek ayarlanır; böylece her ekranda
    // kaydırma sayfanın değil tablonun içinde kalır.
    useEffect(() => {
        return startListTableHeightWatcher()
    }, []);

    useEffect(() => {
        AxiosInterceptor()
        reCreateAuth()
    }, [])

    /**
     * Açılış hangi sebeple yarıda kalırsa kalsın kullanıcı giriş ekranına düşer.
     * Önceden bu fonksiyon hata alınca olduğu yerde kopuyor, "yüklenme bitti" satırına
     * hiç ulaşamıyor ve ekran sonsuza kadar dönüyordu (oturum düşüp firma listesi
     * isteği 401 döndüğünde yaşanan durum buydu).
     */
    const girisEkranina = () => {
        dispatch(storeUser({ isLoading: false, user: undefined }));
    }

    const reCreateAuth = async () => {
        try {
            await reCreateAuthInternal();
        }
        catch (error: any) {
            toast.error("Oturum bilgileri okunamadı, lütfen tekrar giriş yapın.");
            girisEkranina();
        }
    }

    const reCreateAuthInternal = async () => {
        var userStr = await ExpireStorage.getItem(Helpers.getStorageKeys()[0]);

        if (userStr) {
            var user: LoginResponse = JSON.parse(userStr);

            // Sol üstteki şirket seçici: Firma Tanımları'nda Şirket işaretli bütün firmalar (08.10.2026, Burak).
            // Yöneticide Müşteri/Tedarikçi vb. işaretli şirketler (ör. MERS GRUP: Müşteri) listeden düşüyordu;
            // o şirketin rollerini düzenlemek için seçilemiyordu.
            var response2: GetCompanyListResponse = await CompanyService.getCompanyList({ isCompany: true });

            if (!response2.isSuccess) {
                toast.error(response2.message)
                girisEkranina();
                return;
            }

            var selectedCompanyId = localStorage.getItem("SelectedCompanyId");
            var lastSelectedCompanyId = localStorage.getItem("LastSelectedCompanyId");

            if (lastSelectedCompanyId) {
                var controlCompany = response2.data.find(x => x.companyId == lastSelectedCompanyId);

                if (!controlCompany) {
                    localStorage.setItem("SelectedCompanyId", response2.data[0].companyId);
                    localStorage.setItem("LastSelectedCompanyId", response2.data[0].companyId);
                    selectedCompanyId = response2.data[0].companyId;
                }
                else {
                    localStorage.setItem("SelectedCompanyId", controlCompany.companyId);
                    localStorage.setItem("LastSelectedCompanyId", controlCompany.companyId);
                    selectedCompanyId = controlCompany.companyId;
                }
            }
            else {
                localStorage.setItem("SelectedCompanyId", response2.data[0].companyId);
                localStorage.setItem("LastSelectedCompanyId", response2.data[0].companyId);
                selectedCompanyId = response2.data[0].companyId;
            }

            var response3: GetActiveCurrencyConversions = await CurrencyConversionService.getActiveCurrencyConversions();

            if (!response3.isSuccess) {
                toast.error(response3.message)
                girisEkranina();
                return;
            }

            dispatch(storeCurrencyConversionList(response3.data));
            dispatch(storeCompanyList(response2.data))
            dispatch(storeSelectedCompany(response2.data.find(x => x.companyId == selectedCompanyId)))
            setTimeout(() => { dispatch(storeUser({ isLoading: false, user: user })) }, 2000)
            return;
        }
        // else {
        //     var refreshToken = localStorage.getItem(Helpers.getStorageKeys()[4]);
        //     var username = localStorage.getItem(Helpers.getStorageKeys()[5]);

        //     if (refreshToken && username) {
        //         var response: TokenResponse = await ConnectService.refresh_token(refreshToken);

        //         const decoded: JwtModel = jwt_decode(response.access_token);
        //         var _type = typeof (decoded.role)
        //         var authCodes: any = _type === 'string' ? [decoded.role] : decoded.role

        //         var user: UserModel = {
        //             token: response.access_token,
        //             username: username,
        //             authCodes: authCodes,
        //             refreshToken: response.refresh_token
        //         }

        //         await ExpireStorage.setItem(Helpers.getStorageKeys()[0], JSON.stringify(user), (response.expires_in / 60));
        //         await ExpireStorage.setItem(Helpers.getStorageKeys()[1], response.access_token, (response.expires_in / 60));
        //         localStorage.setItem(Helpers.getStorageKeys()[4], response.refresh_token)
        //         localStorage.setItem(Helpers.getStorageKeys()[5], username);
        //         setTimeout(() => { dispatch(storeUser({ isLoading: false, user: user })) }, 2000)
        //         return;
        //     }
        // }



        setTimeout(() => { dispatch(storeUser({ isLoading: false, user: undefined })) }, 2000)
    }

    return (
        <BrowserRouter>
            <Suspense fallback={loading}>
                {/* <Routes> */}
                {
                    auth.user.isLoading
                        ?
                        (
                            <Routes>
                                <Route path="*" element={<LoadingScreen />} />
                            </Routes>
                        )
                        :
                        (
                            <React.Fragment>
                                {
                                    !auth.user.user
                                        ?
                                        (
                                            <Routes>
                                                <Route path="*" element={<LoginScreen />} />
                                            </Routes>
                                        )
                                        :
                                        (
                                            <Routes>
                                                <Route path="*" element={<Layout />} />
                                            </Routes>
                                        )
                                }
                            </React.Fragment>
                        )
                }
                {/* <Route path="/login" element={<Login />} />
                    <Route path="/404" element={<Page404 />} />


                </Routes> */}
            </Suspense>
        </BrowserRouter>
    )
}

export default App;